var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrillectric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1059,
    height: 894,
    viewBox: "0 0 1059 894",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M529.356 354.445L635.495 0L1059 0.701176V199.134H784.02V336.565H1042.54V556.033H784.02V692.762H1058.3V893.649L343 894L663.869 354.445H529.356Z",
    fill: "#13B78C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M635 0H0V197.732H188.642V894H342.22L490.538 520.974H307.507L635 0Z",
    fill: "#00F2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrillectric);
export default __webpack_public_path__ + "static/media/trillectric.d0db0eac1155564a289ccdd5dc9cd79f.svg";
export { ForwardRef as ReactComponent };